import { Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Sidebar from "./SidebarContact";

import { useNavigate, useParams } from "react-router-dom";
import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";
import ContactCard from "./ContactDetailsCard";
import { OverViewNotesContact } from "./OverViewNotesContact";
import { OverViewEmailContact } from "./OverViewEmailContact";
import { OverViewCallContact } from "./OverViewCallContact";
import { OverViewTaskContact } from "./OverViewTaskContact";
import { OverViewMeetingContact } from "./OverViewMeetingContact";
import { OverViewEstimation } from "./OverViewEstimation";
import { OverViewProduct } from "./OverViewProduct";
import { OverViewQuotation } from "./OverViewQuotation";
import { OverViewWorkOrder } from "./OverViewWorkOrder";
import { OverViewPayment } from "./OverViewPayment";
import { OverViewSurveyor } from "../../Masters/LeadDetails/OverViewSurveyor";
import { OverViewInvoices } from "./OverViewInvoices";
import { OverViewPartPayment } from "./OverViewPartPayment";

export const ContactDeatails: React.FC<any> = React.memo((props) => {
  const params = useParams();
  const navigate = useNavigate();
  const id = params?.id;

  const activeSection = params.section || 'overview';

  const [showAllSections, setShowAllSections] = useState<boolean>(false);
  const [leadData, setLeadData] = useState<any>();

  useEffect(() => {
    async function getLeads() {
      const response: any = await callAPI('leads', Method.GET, null, id)
      if (response) {
        setLeadData(response)
      }

    }
    getLeads();
  }, [id])

  const navItems = [
    { id: 'overview', label: 'Overview', icon: '📊' },
    { id: 'notes', label: 'Notes', icon: '📋' },
    { id: 'emails', label: 'Emails', icon: '✉️' },
    { id: 'calls', label: 'Calls', icon: '📞' },
    { id: 'tasks', label: 'Tasks', icon: '✅' },
    { id: 'meetings', label: 'Meetings', icon: '👥' },
    { id: 'products', label: 'Products', icon: '📦' },
    { id: 'estimations', label: 'Estimations', icon: '💰' },
    { id: 'quotations', label: 'Quotations', icon: '📄' },
    { id: 'workorders', label: 'Work Orders', icon: '🛠️' },
    { id: 'payments', label: 'Payments', icon: '💳' },
    { id: 'partpayments', label: 'Part Payments', icon: '💳' },
    { id: 'invoice', label: "Invoice", icon: '' }
  ];

  const visibleItems = showAllSections
    ? navItems
    : navItems.filter((item, index) => index < 4 || item.id === activeSection);

  const hiddenItemsCount = navItems.length - visibleItems.length;

  const renderActiveSection = () => {
    switch (activeSection) {
      case 'overview':
        return <OverViewSurveyor />;
      case 'notes':
        return <OverViewNotesContact />;
      case 'emails':
        return <OverViewEmailContact />;
      case 'calls':
        return <OverViewCallContact />;
      case 'tasks':
        return <OverViewTaskContact />;
      case 'meetings':
        return <OverViewMeetingContact />;
      case 'products':
        return <OverViewProduct />;
      case 'estimations':
        return <OverViewEstimation />;
      case 'quotations':
        return <OverViewQuotation />;
      case 'workorders':
        return <OverViewWorkOrder />;
      case 'payments':
        return <OverViewPayment />;
      case 'partpayments':
        return <OverViewPartPayment />;
      case 'invoice':
        return <OverViewInvoices />;
      default:
        return <OverViewSurveyor />;
    }
  };

  const handleSectionChange = (sectionId: string) => {    
    navigate(`/contacts/${id}/${sectionId}`);
  };


  return (
    <Grid container sx={{ backgroundColor: "#f4f4f9", minHeight: "75vh", p: 2 }}>
      {leadData && (
        <Grid item xs={12} sx={{ mb: 2 }}>
          <ContactCard data={leadData} />
        </Grid>
      )}

      <Grid container spacing={2}>
        {/* Sidebar Navigation */}
        <Grid item xs={12} md={3}>
          <Grid sx={{
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow: 1,
            p: 2,
            height: 'fit-content'
          }}>
            <Typography variant="h6" sx={{ color: "#7D79C2", mb: 1 }}>
              Sections
            </Typography>
            <List>
              {visibleItems.map((item) => (
                <ListItem
                  key={item.id}
                  disablePadding
                  sx={{
                    mb: 0.5,
                    borderRadius: 1,
                    backgroundColor: activeSection === item.id ? '#f0f0ff' : 'transparent',
                    '&:hover': { backgroundColor: '#f8f8ff' }
                  }}
                >
                  <ListItemButton
                    onClick={() => handleSectionChange(item.id)}
                    sx={{
                      py: 1,
                      borderRadius: 1,
                      color: activeSection === item.id ? '#7D79C2' : 'inherit'
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 40, color: 'inherit' }}>
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={item.label}
                      primaryTypographyProps={{
                        fontWeight: activeSection === item.id ? 600 : 400,
                        fontSize: '0.9rem'
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              ))}

              {/* Show More / Show Less Button */}
              {!showAllSections && hiddenItemsCount > 0 && (
                <ListItem disablePadding sx={{ mt: 1 }}>
                  <ListItemButton
                    onClick={() => setShowAllSections(true)}
                    sx={{
                      py: 1,
                      borderRadius: 1,
                      backgroundColor: '#f8f8ff',
                      '&:hover': { backgroundColor: '#f0f0ff' }
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      ⬇️
                    </ListItemIcon>
                    <ListItemText
                      primary={`Show More (${hiddenItemsCount})`}
                      primaryTypographyProps={{
                        fontWeight: 500,
                        color: '#7D79C2',
                        fontSize: '0.9rem'
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              )}

              {showAllSections && (
                <ListItem disablePadding sx={{ mt: 1 }}>
                  <ListItemButton
                    onClick={() => setShowAllSections(false)}
                    sx={{
                      py: 1,
                      borderRadius: 1,
                      backgroundColor: '#f8f8ff',
                      '&:hover': { backgroundColor: '#f0f0ff' }
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      ⬆️
                    </ListItemIcon>
                    <ListItemText
                      primary="Show Less"
                      primaryTypographyProps={{
                        fontWeight: 500,
                        color: '#7D79C2',
                        fontSize: '0.9rem'
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              )}
            </List>
          </Grid>
        </Grid>

        {/* Main Content Area */}
        <Grid item xs={12} md={9}>
          <Grid container spacing={2}>
            {/* Main Content Section */}
            <Grid item xs={12} lg={8}>
              {/* <Grid sx={{
                backgroundColor: "white",
                borderRadius: 2,
                boxShadow: 1,
                p: { xs: 2, sm: 3 },
                minHeight: '400px'
              }}>
                
              </Grid> */}
              {renderActiveSection()}
            </Grid>

            {/* Sidebar */}
            <Grid item xs={12} lg={4}>
              {leadData && <Sidebar data={leadData} />}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
});
